import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { lazy, Suspense } from "react";
import { datadogRum } from "@datadog/browser-rum";
import Navbar from "./components/Navbar/Navbar";
import { useState, useEffect } from "react";
import { useAuth } from "./store/context/auth";
import Footer from "./components/Footer/Footer";
import "./App.scss";
import { useSelector, useDispatch } from "react-redux";
import ProtectedRoutes from "./components/ProtectedRoutes/ProtectedRoutes";
import LoadingPage from "./components/UI/LoadingPage/LoadingPage";
import { setConfig } from "./store/redux/config";
import CustomAlert from "./components/UI/CustomAlert/CustomAlert";
import { Box, Button } from "@mui/material";
import { updateTokens } from "./util/http";
import { getDeviceId } from "./util/utilfunctions/utilFunctions";
import { setDeviceToken } from "./store/redux/login";
import { checkSession } from "./util/API/sessions";
import { setResetSession } from "./util/API/sessions";
import { setScrollPosition } from "./store/redux/scrollPosition";
import PayrollBatch from "./pages/PayrollBatch/PayrollBatch";

import { setLoggedInUser, setAuthenticatedLoggedInUsers } from "./store/redux/login";
import CRM from "./pages/CRM/CRM";
import Dashboard from "./pages/Dashboard/Dashboard";
import Operator from "./pages/Operator/Operator";
import Admin from "./pages/Admin/Admin";

import Reporting from "./pages/Reporting/Reporting";
import Loans from "./pages/Loans/Loans";
import Transfers from "./pages/Transfers/Transfers";
import CardServices from "./pages/CardServices/CardServices";
import ATMServices from "./pages/ATMServices/ATMServices";
import Remittance from "./pages/Marketplace/Remittance/Remittance";
import CreditScore from "./pages/CreditScore/CreditScore";
import Treasury from "./pages/Treasury/Treasury";
import Accounting from "./pages/Accounting/Accounting";
import Unauthorized from "./pages/Unauthorized/Unauthorized";
import Settings from "./pages/Settings/Settings";
import LoanReports from "./pages/LoanReports/LoanReports";
import LoanSetup from "./pages/LoanSetup/LoanSetup";
import UserReports from "./pages/UserReports/UserReports";
import Marketplace from "./pages/Marketplace/Marketplace";
import CoFilab from "./pages/CoFilab/CoFilab";
import CoFiMarketplace from "./pages/CoFilab/CoFiMarketplace/CoFiMarketplace";
import Login from "./pages/Login/Login";
import Program from "./pages/Program/Program";
import RolesAndPermissions from "./pages/RolesAndPermissions/RolesAndPermissions";
import Compliance from "./pages/Compliance/Compliance";
import Batch from "./pages/Batch/Batch";
import Agents from "./pages/Agents/Agents";
import DeviceManagement from "./pages/DeviceManagement/DeviceManagement";
import UserOFACReports from "./pages/UserOFACReports/UserOFACReports";
import PayrollAdmin from "./pages/PayrollAdmin/PayrollAdmin";
import PayrollAdminReports from "./pages/PayrollReports/PayrollAdminReports";
import SuperAdminPayrollReports from "./pages/SuperAdminPayrollReports/SuperAdminPayrollReports";

import Fees from "./pages/FeesModule/Fees";
import LoanRules from "./pages/LoanRules/LoanRules";
import CoFi from "./pages/CoFi/CoFi";
import Portfolio from "./pages/Portfolio/Portfolio";
import DeepDD from "./pages/DeepDD/DeepDD";
import DeepDDSettings from "./pages/DeepDD/DeepDDSettings";


import TransactionHistory from "./pages/Transactions/TransactionsHistory"
import WidgetDashboard from "./pages/WidgetDashboard/WidgetDashboard";
import SetupPlansPackages from "./pages/FeesModule/SetupPlansPackages";
import mixpanel from 'mixpanel-browser';

// Optimize load time
// const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
// const CRM = lazy(() => import("./pages/CRM/CRM"));
// const Operator = lazy(() => import("./pages/Operator/Operator"));
// const Admin = lazy(() => import("./pages/Admin/Admin"));

// const Reporting = lazy(() => import("./pages/Reporting/Reporting"));
// const Loans = lazy(() => import("./pages/Loans/Loans"));
// const Transfers = lazy(() => import("./pages/Transfers/Transfers"));
// const CardServices = lazy(() => import("./pages/CardServices/CardServices"));
// const ATMServices = lazy(() => import("./pages/ATMServices/ATMServices"));
// const Remittance = lazy(() => import("./pages/Marketplace/Remittance/Remittance"));
// const CreditScore = lazy(() => import("./pages/CreditScore/CreditScore"));
// const Treasury = lazy(() => import("./pages/Treasury/Treasury"));
// const Accounting = lazy(() => import("./pages/Accounting/Accounting"));
// const Unauthorized = lazy(() => import("./pages/Unauthorized/Unauthorized"));
// const Settings = lazy(() => import("./pages/Settings/Settings"));
// const LoanReports = lazy(() => import("./pages/LoanReports/LoanReports"));
// const LoanSetup = lazy(() => import("./pages/LoanSetup/LoanSetup"));
// const UserReports = lazy(() => import("./pages/UserReports/UserReports"));
// const Marketplace = lazy(() => import("./pages/Marketplace/Marketplace"));
// const CoFilab = lazy(() => import("./pages/CoFilab/CoFilab"));
// const CoFiMarketplace = lazy(() => import("./pages/CoFilab/CoFiMarketplace/CoFiMarketplace"));
// const Login = lazy(() => import("./pages/Login/Login"));
// const Program = lazy(() => import("./pages/Program/Program"));
// const RolesAndPermissions = lazy(() => import("./pages/RolesAndPermissions/RolesAndPermissions"));
// const Compliance = lazy(() => import("./pages/Compliance/Compliance"));
// const Batch = lazy(() => import("./pages/Batch/Batch"));
// const Agents = lazy(() => import("./pages/Agents/Agents"));
// const DeviceManagement = lazy(() => import("./pages/DeviceManagement/DeviceManagement"));
// const UserOFACReports = lazy(() => import("./pages/UserOFACReports/UserOFACReports"));

function App() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showSessionExpiredAlert, setShowSessionExpiredAlert] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showReloadPrompt, setShowReloadPrompt] = useState(false);
  const [newVersion, setNewVersion] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const sidebarOpen = useSelector((state) => state.ui.sidebarOpen);

  // Retrieving user details from session storage and Redux store
  const authUser = sessionStorage.getItem("user");
  const userInfo = useSelector((state) => state.login.user);
  const auth = useAuth();
  const path = useLocation().pathname;
  // Permissions data for role-based access control
  const userRoles = useSelector((state) => state.login.securityAccess);
  let securityRoleId = sessionStorage.getItem("userSecurityRoleId");

  const isAuthenticated = Boolean(authUser && userInfo);
  const { resetSession } = useAuth();
  setResetSession(resetSession);

  // Check app version and depending if new version is deployed display reload btn.
  useEffect(() => {
  const currentVersion = localStorage.getItem("app_version");

  fetch('/version.json', { cache: 'no-cache' })
    .then(res => res.json())
    .then(data => {
      if (currentVersion && data.version !== currentVersion) {
        // Show prompt only if there's a mismatch
        setShowReloadPrompt(true);
        setNewVersion(data.version); // Save the new version to apply later
      } else if (!currentVersion) {
        // Optional: On very first load, silently set the version
        localStorage.setItem("app_version", data.version);
      }
    })
    .catch(err => {
      console.error('Failed to fetch version.json:', err);
    });
}, []);

  // Effect to control when the idle timer should start or pause
  useEffect(() => {
    const isAuthenticated = Boolean(authUser && userInfo);

    if (isAuthenticated) {
      // start(); // Start the idle timer
      let interval = setInterval(async () => {
        try {
          const response = await checkSession();
          if (response?.header?.callStatus === "0" || response?.result) {
            auth.logout();
            auth.resetSession();
          }
        } catch (error) {
          console.error("Session check failed:", error);
        }
      }, 30000); // Call checkSession every 30 seconds

      return () => clearInterval(interval); // Cleanup on unmount or when dependencies change
    } else {
      // pause(); // Pause the idle timer
    }
  }, [authUser, userInfo, checkSession]);

  useEffect(()=>{
    console.log("sidebarOpen------------",sidebarOpen);
  },[sidebarOpen])

  const getDeviceToken = async() => {
    const deviceID = await getDeviceId();
    return deviceID;
  }

  useEffect(() => {
    const updateDeviceToken = async () => {
      if (isAuthenticated) {
        if (!sessionStorage.getItem("viewID")) {
          const viewID = crypto.randomUUID();
          sessionStorage.setItem("viewID", viewID);
        }
        const deviceToken = await getDeviceToken();
        dispatch(setDeviceToken(deviceToken));
      }
    };
  
    updateDeviceToken();
  }, [isAuthenticated]);

  // // Whenever the user performs an action, reset the timer
  // useEffect(() => {
  //   if (isAuthenticated) {
  //     reset(); // Reset the idle timer when the user is authenticated
  //   }
  // }, [authUser, userInfo, reset]);

  // Replace all space-like characters with standard spaces
  const sanitizeLabel = (label) => {
    return label.replace(/\s/g, " ");
  };

  // Function to check if the current user has the required permission to access a component
  const checkPermission = (component, permissionLabel, appId) => {
    //The paramater should be the component and the permission label comes from the userrole that is set in the state during login
    const sanitizedPermissionLabel = sanitizeLabel(permissionLabel);

    // console.log(sanitizedPermissionLabel)

    let hasPermission

    // console.log("checkPermission_userRoles------------",userRoles)
    // // console.log("checkPermission_permissionLabel------------",permissionLabel)
    
    
    if (userRoles) {
      if (!Array.isArray(userRoles)) {
        hasPermission = 
        userRoles.appid === appId ||
        userRoles.label.toLowerCase().includes(sanitizedPermissionLabel.toLowerCase()) ||
        userRoles.label.toLowerCase().includes("head office")
      }
      else {
        // console.log("checkPermission_userRoles------------",userRoles)

        if((securityRoleId == '844'  || securityRoleId == '707') && permissionLabel == 'Report') {
          hasPermission = true;
        } else {
          hasPermission = userRoles.some((role) => {
            // console.log("checkPermission_permissionLabel------------",appId)
            // console.log("checkPermission_permissionLabel2------------",role.appid)
            // console.log("checkPermission_checkIfTRUE------------",role.appid == appId)

            const sanitizedRoleLabel = sanitizeLabel(role.label.toLowerCase()); // Ensure label is sanitized and lowercase
            const sanitizedKeyword = sanitizedPermissionLabel.toLowerCase(); // Make sure the keyword is also lowercase
            // console.log(sanitizedRoleLabel, sanitizedKeyword)
            // console.log(sanitizedRoleLabel.includes("head office"))
            return role.appid === appId || sanitizedRoleLabel.includes(sanitizedKeyword) 
            || sanitizedRoleLabel.includes("head office")
          });
        }

      }

      // console.log(hasPermission, userRoles, component.type.name)

      return hasPermission ? (
        component
      ) : (
        <Navigate to="/unauthorized" state={{ page: permissionLabel }} />
      );
    }
  };

  //This is taking the JSON file and setting it to the config state but eventually it will be replaced by the API call
  useEffect(() => {
    setIsLoading(true);
    fetch("./config.json")
      .then((response) => response.json())
      .then((data) => {
        dispatch(setConfig(data));
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Failed to load configuration", error);
        setIsLoading(false);
      });
  }, []);

  // Effect to dynamically load an external script when not on the homepage
  useEffect(() => {
    if (location.pathname !== "/") {
      const script = document.createElement("script");
      script.src =
        "https://static.zdassets.com/ekr/snippet.js?key=9c1340a4-74a0-497e-bab0-731678180733";
      script.id = "ze-snippet";
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [location.pathname]);

  // Effect to handle window scroll events for storing the scroll position in Redux to display titles in navbar when logged in
  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      dispatch(setScrollPosition(position));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dispatch]);

  // console.log(JSON.parse(authUser))

  // Effect to manage user session and navigation based on authentication state
  useEffect(() => {
    if (authUser && !userInfo) {
      const userData = JSON.parse(authUser);
      dispatch(setAuthenticatedLoggedInUsers(userData));
      // console.log(userData);
      dispatch(setLoggedInUser(userData));
      // console.log(authUser && !userInfo)
      // console.log(userInfo)
      if (path == "/") {
        navigate("/settings");
      }
      if (window.zE) {
        window.zE(function () {
          window.zE.show();
        });
      }
    } else if (!authUser) {
      navigate("/");
      sessionStorage.clear();
      if (window.zE) {
        window.zE(function () {
          window.zE.hide();
        });
      }
    }
  }, [authUser, userInfo, dispatch, navigate]);

  const isLoginRoute = path === "/";

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <Box className="App">
      {!isLoginRoute && (
        <Navbar style={{ position: "fixed", top: "0", zIndex: "100000", width: '100%' }} />
      )}

      {showReloadPrompt && (
        <div style={{
          position: 'fixed',
          top: 10,
          // bottom: 10,
          right:10,
          // left: 10,
          background: '#333',
          color: '#fff',
          padding: '10px 20px',
          borderRadius: '5px',
          zIndex: 100000,
        }}>
          A new version is available.
          <Button
            className="paiy-green text-white"
            onClick={() => {
              if (newVersion) {
                localStorage.setItem("app_version", newVersion);
              }
      
              // Cache-busting reload
              window.location.href = window.location.pathname + '?v=' + new Date().getTime();
            }}
            style={{ marginLeft: 10, color: '#000' }}
          >
            Reload
          </Button>
        </div>
      )}

      <Box 
        className="home" 
        sx={{
          overflowY: 'auto',
          transition: 'width 0.3s ease',
          // width: sidebarOpen ? 'calc(100% - 343px)' : '100%',
          marginLeft: sidebarOpen ? "200px" : "0px",
          width: sidebarOpen ? "calc(100% - 200px)" : "100%",
        }}
        // sx={{ overflowY: 'auto' }}
        // style={{ width: "calc(100% - 200px)" }}
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route element={<ProtectedRoutes />}>
              <Route
                path="/batch"
                element={checkPermission(<Batch />, "Admin", "400020001")}
              />
              <Route 
                path="/payrollbatch" 
                element={checkPermission(<PayrollBatch />, "Payroll Batch", "400020002")}
                 />

                 <Route
                        path="/payrollreports"
                        element={checkPermission(<PayrollAdminReports />, "Admin", "400020002")}
                      />

                      <Route
                path="/superadmin-payroll-reports"
                element={checkPermission(<SuperAdminPayrollReports />, "Admin", "400110001")}
              />
                 
                    <Route
                      path="/payrolladmin"
                      element={checkPermission(<PayrollAdmin />, "Admin", "400110001")}
                                          />
              <Route
                path="/CRM"
                // element={checkPermission(<CRM />, "Portal CRM")}
                element={checkPermission(<CRM />, "CRM", "400010001")}
              />
              <Route
                path="/transfers"
                element={checkPermission(<Transfers />, "CRM", "400120001")}
              />
              <Route
                path="/dashboard"
                element={checkPermission(<Dashboard />, "CRM", "400090001")}
                // element={<Dashboard />}
              />
              <Route
                path="/program"
                element={checkPermission(<Program />, "Program", "400110001")}
              />
              <Route
                path="/admin"
                // element={<Admin />}
                element={checkPermission(<Admin />, "Admin", "400110001")}
              >
                <Route path="users" element={<Admin />} />
              </Route>
              <Route
                path="/admin/roles"
                element={checkPermission(<RolesAndPermissions />, "Roles", "400110001")}
              />
              <Route
                path="/compliance"
                element={checkPermission(<Compliance />, "Compliance", "")}
              />
              <Route
                path="/reporting"
                element={checkPermission(
                  <Reporting />,
                  "Report",
                  "400080001"
                )}
              />
              <Route
                path="/userreporting"
                element={checkPermission(
                  <UserReports />,
                  "User Reports",
                  "400160002"
                )}
              />
              <Route
                path="/journaltransactions"
                element={checkPermission(
                  <TransactionHistory />,
                  "Transactions Journal",
                  "400160007"
                )}
              />
              <Route
                path="/portfolio"
                element={checkPermission(
                  <Portfolio />,
                  "Portfolio",
                  "400160002"
                )}
              />
              <Route
                path="/ofacreporting"
                element={checkPermission(
                  <UserOFACReports />,
                  "User Reports",
                  "400160002"
                )}
              />
              <Route
                path="/cofi"
                element={checkPermission(
                  <CoFi />,
                  "CoFi",
                  "400160005"
                )}
              />
              <Route
                path="/DeepDD"
                element={checkPermission(
                  <DeepDD />,
                  "DeepDD",
                  "400160020"
                )}
              />
              <Route
                path="/DeepDD/settings"
                element={checkPermission(
                  <DeepDDSettings />,
                  "DeepDD",
                  "400160020"
                )}
              />
              <Route
                path="/Treasury"
                element={checkPermission(<Treasury />, "Treasury", "400040001")}
                // element={<Treasury />}
              />
              <Route
                path="/widgetdashboard"
                element={checkPermission(<WidgetDashboard />, "WidgetDashboard", "400040001")}
                // element={<Treasury />}
              />
              <Route
                path="/setupplanspackages"
                element={checkPermission(<SetupPlansPackages />, "SetupPlansPackages", "400040001")}
                // element={<Treasury />}
              />
              <Route
                path="/accounting"
                element={checkPermission(<Accounting />, "Accounting", "400050001")}
              />
              <Route
                path="/settings"
                element={checkPermission(<Settings />, "Admin", "400070001")}
                // element={<Settings />}
              />
              <Route
                path="/loans"
                // element={<Loans />}
                element={checkPermission(<LoanReports />, "Admin", "400140001")}
                // element={checkPermission(<Loans />, "Admin", "400140001")}
              />
              <Route
                path="/loanreports"
                element={checkPermission(<LoanReports />, "Admin", "400110001")}
              />
              <Route
                path="/loansetup"
                element={checkPermission(<LoanSetup />, "Admin", "400110001")}
              />

              <Route
                    path="/loan-rule-setup"
                    element={checkPermission(<LoanRules />, "Admin", "400110001")}
                  />
              <Route
                path="/fees-setup"
                element={checkPermission(<Fees />, "Admin", "400110001")}
              />
              <Route
                path="/agents"
                element={checkPermission(<Agents />, "Admin", "400130001")}
              />
              <Route
                path="/operators"
                // element={<Operator />}
                element={checkPermission(<Operator />, "Operator", "400100001")}
              />
              <Route
                path="/devicemanagement"
                // element={<DeviceManagement />}
                element={checkPermission(<DeviceManagement />, "Admin", "400000001")}
              />
              <Route
              path="/atmservices"
              // element={<ATMServices />}
              element={checkPermission(<ATMServices />, "ATM Services", "400160001")}
              />
              <Route
                path="/marketplace"
                element={checkPermission(<Marketplace />, "Portal Settings", "400070001")}
              />
              <Route
                path="/marketplace/remittance"
                element={checkPermission(<Remittance />, "Portal Settings", "400070001")}
              />
              <Route
                path="/cofilab"
                element={checkPermission(<CoFilab />, "Portal Settings", "400070001")}
              />
              <Route
                path="/cofilab/cofimarketplace"
                element={checkPermission(<CoFiMarketplace />, "CoFi Marketplace", "")}
              />

              <Route
                path="/credit-scoring"
                element={checkPermission(<CreditScore />, "Portal Settings", "400070001")}
              />

              <Route
                path="/cardservices"
                // element={<CardServices />}
                element={checkPermission(<CardServices />, "Card Services", "400150001")}
              />

            </Route>
            <Route path="/unauthorized" element={<Unauthorized />} />

            <Route path="/" element={<Login />} />
          </Routes>
        </Suspense>
      </Box>
      <Footer />
      {showSessionExpiredAlert && (
      <CustomAlert
        severity={showSessionExpiredAlert.severity}
        show={showSessionExpiredAlert.show}
        header={showSessionExpiredAlert.header}
        message={showSessionExpiredAlert.message}
        onClick={() => {setShowSessionExpiredAlert(false); auth.logout()}}
      />
    )}
    </Box>
  );
}

export default App;
